"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Section = styled_components_1.default.div `
	margin-top: 2rem;
`;
const SectionTitle = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.gray8};
	margin-bottom: 1rem;
	font-size: 1rem;
`;
const PreviewSection = ({ title, children }) => {
    return ((0, jsx_runtime_1.jsxs)(Section, { children: [(0, jsx_runtime_1.jsx)(SectionTitle, { children: title }), children] }));
};
exports.PreviewSection = PreviewSection;
